export enum FeeStatus {
    Done = 'done',
    Pending = 'pending',
}
